import React, { useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import useMediaQuery from "../../hooks/useMediaQuery";

import FiltersRcofHistory from "./FiltersRcofHistory";
import RcofHistoryTables from "./RcofHistoryTables";

import AuthContext from "../../context/authentication/authContext";
import PortalContext from "../../context/portal/portalContext";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    //padding: theme.spacing(3),
    height: "738px",
  },
  componentTitle: {
    fontSize: "24px",
    color: "#263AE3",
    marginBottom: 15,
  },
}));

const Transactions = () => {
  const authContext = useContext(AuthContext);
  const portalContext = useContext(PortalContext);
  const { authenticatedUser } = authContext;
  const { terminals, getDashboardData } = portalContext;

  useEffect(() => {
    authenticatedUser();
    getDashboardData();
  }, []);

  const classes = useStyles();
  const isMobile = useMediaQuery("max-width", 600);
  return (
    <div
      className={classes.root}
      style={{ padding: !isMobile ? "24px" : "0px" }}
    >
      <Grid container spacing={3} style={{ marginBottom: "60px" }}>
        {!isMobile && (
          <Grid item xs={4}>
            <Typography className={classes.componentTitle}>
              RCOF Históricos
            </Typography>
            <FiltersRcofHistory terminals={terminals} />
          </Grid>
        )}
        <Grid item xs={!isMobile ? 8 : 12}>
          <Grid item xs={12}>
            <RcofHistoryTables />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Transactions;
